export default __webpack_public_path__ + "static/media/portrait3.e4c57614.png";